
<prism-ui-page-content
  [illustrationUrl]="pageIllustrationUrl"
  [illustrationTop]="true"
  key-id="page-content"
  illustration-top="true"
  custom-max-width="720"
  >
  <div class="page-content" data-testid="confirmation" page-content>

  <prism-ui-heading
    key-id="confirmation-title"
    level="1"
    font-size="lg"
    line-height="medium"
    font-weight="regular"
  >
    {{sectionTitle}}
  </prism-ui-heading>

    <div class="topPadding bottomPadding">
     
     <div class="confirmation-applicant-types">  
        <div class="item">
          <prism-ui-heading
              key-id="notification-toast"
              font-size="xs"
              font-weight="strong"
              line-height="loose"
            >
              {{ confirmationTitle }}
            </prism-ui-heading>
            <prism-ui-copy key-id="notification-toast-msg" line-height="loose">
              {{ confirmationMsg }}
            </prism-ui-copy>
        </div>  

        @for (item of selectedApplicantTypes; track $index) {
          @if (item?.toLowerCase() === 'child') {
            <!-- Loop child cards based on childCount -->
            @for (childNum of getChildArray(); track childNum) {
              <div class="item">
                <prism-ui-action-card
                  is-small="false"
                  [key-id]="'child-' + childNum"
                  [card-title]="'Child ' + childNum "
                >
                  <div slot="heading">
                    <prism-ui-heading key-id="complex" font-size="xs">
                      {{ 'Child ' + childNum }}
                    </prism-ui-heading>
                  </div>

                  <img slot="icon" src="assets/stylized-icons/file.svg" alt="file"/>

                  <div slot="supplemental" class="supplemental">
                    @if (isSubmitted(item, childNum)) {
                      <prism-ui-tag key-id="child-status" variant="good">Submitted</prism-ui-tag>
                          &nbsp;&nbsp;<prism-ui-copy key-id="child-date" font-size="sm">{{ date }}</prism-ui-copy>
                    } @else {
                      <prism-ui-tag key-id="child-status" variant="focus">Not Started</prism-ui-tag>
                    }
                    
                  </div>

                  @if (shouldShowButton(item, childNum)) {
                    <div slot="action" class="action">
                      <prism-ui-button
                        [key-id]="'child-action-' + childNum"
                        [variant]="getButtonVariant(item, childNum)"
                        is-icon-right-aligned="false"
                        button-width="full"
                        icon-name="chevron-right-light"
                        size="sm"
                        [iconName]="getButtonIcon(item, childNum)"
                        (click)="handleCardAction(item, childNum)"
                      >
                        {{ getButtonLabel(item, childNum) }}
                      </prism-ui-button>
                    </div>
                  }
                </prism-ui-action-card>
              </div>
            }
          } @else {
            <!-- Regular applicant type cards (Employee, Spouse) -->
             <div class="item">
                <prism-ui-action-card
                  is-small="false"
                  [key-id]="item?.toLowerCase()"
                  [card-title]="getCardTitle(item)"
                >
                  <div slot="heading">
                    <prism-ui-heading key-id="complex" font-size="xs">
                      {{ getCardTitle(item) }}
                    </prism-ui-heading>
                  </div>

                  <img slot="icon" src="assets/stylized-icons/file.svg" alt="file"/>

                  <div slot="supplemental" class="supplemental">
                    @if (isSubmitted(item)) {
                      <prism-ui-tag [key-id]="item + '-status'" variant="good">Submitted</prism-ui-tag>
                          &nbsp;&nbsp;<prism-ui-copy [key-id]="item + '-date'" font-size="sm">{{ date }}</prism-ui-copy>
                    } @else {
                      <prism-ui-tag [key-id]="item + '-status'" variant="focus">Not Started</prism-ui-tag>
                    }
              
                  </div>

                  @if (shouldShowButton(item)) {
                    <div slot="action" class="action">
                      <prism-ui-button
                        [key-id]="item + '-action'"
                        [variant]="getButtonVariant(item)"
                        is-icon-right-aligned="false"
                        button-width="full"
                        icon-name="chevron-right-light"
                        size="sm"
                        [iconName]="getButtonIcon(item)"
                        (click)="handleCardAction(item)"
                      >
                        {{ getButtonLabel(item) }}
                      </prism-ui-button>
                    </div>
                  }
                </prism-ui-action-card>
            </div>
          }
        }
      </div>
    </div>

    
    <prism-ui-container
      is-compact="false"
      key-id="next-steps"
      has-shadow="false"
      variant="default"
      has-no-border-radius="false"
    >
      <br>
        <div class="image-txt-container">
            <div class="col leftPadding">

                <prism-ui-heading 
                font-size="sm" 
                font-weight="strong" 
                key-id="next-steps-title" 
                style="margin-bottom: 30px;"
                >
                  {{nextStepsTitle}}
              </prism-ui-heading>

                <prism-ui-copy
                font-size="md"
                font-style="normal"
                font-weight="regular"
                key-id="next-steps-body"
                line-height="loose"
              >
              <span [innerHTML]="nextStepsBody"> </span>
              </prism-ui-copy>

        </div>
    </div>
    </prism-ui-container>
    <br>     
    <br>

    <div class="row">
      <prism-ui-button
        button-width="content"
        key-id="instructions-button"
        size="md"
        variant="secondary"
        type="submit"
        (click)="startAnotherStatement()"
      >
        Exit
      </prism-ui-button>
  </div>
   
</div>
</prism-ui-page-content>

<prism-ui-modal key-id="cancel-modal" has-dark-overlay="true">
  <prism-ui-heading
    slot="modal-header"
    key-id="cancel-modal"
    font-size="sm"
    font-weight="strong"
    >{{modalContentHeading}}</prism-ui-heading
  >
  <prism-ui-copy
    slot="modal-body"
    key-id="cancel-modal"
  >
    {{modalContentBody}}
  </prism-ui-copy>
  <div slot="modal-footer">
      <div class="modalButtonStyling">
          <prism-ui-button
              button-width="full"
              key-id="cancel-button"
              size="md"
              variant="secondary"
              type="button"
              is-icon-right-aligned="false"
              (click)="onCancelModal('prism-ui-modal-cancel-modal')"
          >Cancel</prism-ui-button>
          <prism-ui-button class="leftPaddingSmall"
              button-width="full"
              key-id="continue-button"
              size="md"
              variant="primary"
              type="button"
              is-icon-right-aligned="false"
              (click)="leaveAnyway()"
          >Leave Anyway</prism-ui-button>
      </div>
  </div>
</prism-ui-modal>